/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gallery_Public_OnlyInputs */

const cs_gallery_public_only = /** @type {(inputs: Gallery_Public_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export na portály a web používá celý tento seznam v pořadí. Fotky spravujte zde — ne na záložce Portály.`)
};

const en_gallery_public_only = /** @type {(inputs: Gallery_Public_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portal export and the website use this full list in order. Manage photos here — not on the Portals tab.`)
};

/**
* | output |
* | --- |
* | "Portal export and the website use this full list in order. Manage photos here — not on the Portals tab." |
*
* @param {Gallery_Public_OnlyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const gallery_public_only = /** @type {((inputs?: Gallery_Public_OnlyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gallery_Public_OnlyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gallery_public_only(inputs)
	return cs_gallery_public_only(inputs)
});